@switch (type) {
  @case ('info') {
    <fa-icon class="me-3" [icon]="faInfoCircle" size="lg" [style.color]="infoIconAccentColor"></fa-icon>
  }
  @case ('warning') {
    <fa-icon class="me-3" [icon]="faExclamationCircle" size="lg"></fa-icon>
  }
  @case ('alert') {
    <fa-icon class="me-3" [icon]="faExclamationTriangle" size="lg"></fa-icon>
  }
}
<div>
  <ng-content></ng-content>
</div>
